<script>
    import Opportunity from './Opportunity.svelte'

    import { Container } from '@/components'

    const opportunities = [
        {
            title: 'Сотрудники',
            circleColor: '#F3954A',
            gradient: 'employee',
            videoName: 'employee',
            items: [
                'Скачивают автоматические справки: остаток<br/> отпуска, расчётный лист',
                'Загружают новые паспортные данные',
                'Заполняют график отпусков на год и предлагают<br/> изменения, если нужно его подвинуть',
                'Пишут заявление на отпуск, отправляют<br/> на согласование руководителю и HR',
                'Согласовывают командировки, отправляют<br/> авансовые отчёты',
                'Отправляют больничные и фиксируют<br/> переработки',
                'Заказывают справки в бухгалтерии или HR,<br/> например, 2НДФЛ',
                'Отслеживают статус заявлений и готовности<br/> документов'
            ]
        },
        {
            title: 'HR-менеджеры',
            circleColor: '#A461CD',
            gradient: 'hr',
            videoName: 'hr',
            items: [
                'Берут в работу заявки на предоставление справок',
                'Отслеживают статусы документов, например,<br/> заявлений на отпуск по всем сотрудникам',
                'Просматривают, фильтруют, выгружают<br/> HR-отчёты',
                'Отслеживают историю действий',
                'Заводят личный кабинет кандидатам в процессе<br/> трудоустройства, чтобы они сами загружали<br/> персональные данные и сканы документов<br/> для проверки',
                'Вместе с руководителями составляют документ<br/> оценки персонала и отслеживают статистику'
            ],
            direction: 'right'
        },
        {
            title: 'Руководители',
            circleColor: '#4A8EF3',
            gradient: 'boss',
            videoName: 'boss',
            items: [
                'Видят календари рабочего времени своих<br/> подчинённых и планируют нагрузку отдела',
                'Согласовывают графики отпусков на год<br/> и отслеживать их изменение',
                'Согласовывают или отклоняют заявление на отпуск<br/> одним кликом и могут прокомментировать решение',
                'Помогают сотрудникам без доступа<br/> к сетевым ресурсам подать заявление<br/> или оформить командировку',
                'Просматривают управленческую структуру, видят<br/> цепочки согласований',
                'Назначают заместителя на время отпуска или<br/> ответственного за все кадровые процессы отдела'
            ],
        }
    ]
</script>

<Container>
    <h2 class="title">И упрощает работу сотрудников,<br/>
    руководителей и HR-менеджеров</h2>
</Container>

{#each opportunities as { title, circleColor, items, direction, gradient, videoName }, i }
    <Container>
        <Opportunity {title} {circleColor} {items} {direction} {videoName}>
            <div slot="afterButton">
                {#if i === 2}
                    <p>С 2022 года регулировать трудовые отношения можно электронно.<br/> 
                    Это значит, что для официального подписания кадровых<br/> 
                    документов можно использовать электронную подпись и всё<br/> 
                    проводить в EmployeeGate.</p>

                    <p>Подробнее о внедрении кадрового электронного<br/> 
                    документооборота в компании читайте на сайте <a class="link" href="https://www.ucmsgroup.ru">UCMS Group</a>.</p>
                {/if}
            </div>
        </Opportunity>

        <div class="background" slot="background">
            <div class="gradient {gradient}" style={`background-image: url('../img/gradients/opportunities/${gradient}.jpg');`} />
        </div>
    </Container>
{/each}

<style lang="scss">
    .title {
        margin-bottom: 50px;
        
        @media (max-width: 600px) {
            margin-bottom: 40px;
        }
    }

    .background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: end;

        .gradient {
            width: calc(450px + ((100% - 1280px) / 2));
            min-width: 450px;
            height: 750px;
            margin-left: auto;
            background-repeat: no-repeat;
            background-size: cover;

            @media (max-width: 935px) {
                position: absolute;
                top: 50px;
                right: 0;
            }

            @media (max-width: 834px) {
                width: calc((250 / 834) * 100%);
                min-width: unset;
                height: 498px;
            }

            @media (max-width: 600px) {
                display: none;
            }

            @media (max-width: 420px) {
                width: calc((200 / 320) * 100%);
                height: 396px;
            }

            &.hr {
                margin-left: 0;
                background-position-x: right;

                @media (max-width: 935px) {
                    position: absolute;
                    top: 50px;
                    left: 0;
                }
            }
        }
    }
</style>


